import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpEventType} from '@angular/common/http';
import {API} from '@configs/api.config';
import {FileInfo} from '@shared/models/file-info';
import {PreSignedUrl} from '@control-tower/models/jpm/pre-signed-url';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileHandlerService {

  constructor(private httpClient: HttpClient) {
  }

  uploadFile(orgId: string, path: string[], file: File): Observable<FileInfo> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    const url = API.fileHandelar.uploadFile.format([orgId, path.toString()]);
    return this.httpClient.post<FileInfo>(url, formData);
  }

  uploadFileStream(orgId: string, path: string[], file: File, heading?: string): Observable<HttpEvent<FileInfo>> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    if (heading) {
      formData.append('heading', heading);
    }
    const url = API.fileHandelar.uploadFileStream.format([orgId, path.toString()]);
    return this.httpClient.post<FileInfo>(url, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  fetchFile(fileId: string): Observable<PreSignedUrl> {
    const url = API.fileHandelar.fetchThumbnail.format([fileId]);
    return this.httpClient.get<PreSignedUrl>(url);
  }

  fetchOriginalFile(fileId: string): Observable<PreSignedUrl> {
    const url = API.fileHandelar.getPreSignedUrl.format([fileId]);
    return this.httpClient.get<PreSignedUrl>(url);
  }

  fetchFiles(fileIds: string[]): Observable<PreSignedUrl[]> {
    const url = API.fileHandelar.fetchThumbnails;
    return this.httpClient.post<PreSignedUrl[]>(url, fileIds);
  }
}
